<template>
  <Modal :title="$t('CROP_IMAGE_MODAL_HEADER')" v-bind="$attrs">
    <template #content>
      <div class="modal" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal__header">
          <p>{{ $t('CROP_IMAGE_MODAL_HEADER') }}</p>
        </div>
        <div class="modal__actions">
          <button
            type="button"
            class="btn btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="$emit('closed')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="25"
              viewBox="0 0 26 25"
              fill="none">
              <path
                d="M2 23L23.9203 1.07969"
                stroke="white"
                stroke-width="3"></path>
              <path
                d="M24 23L2.07969 1.07969"
                stroke="white"
                stroke-width="3"></path>
            </svg>
          </button>
        </div>
        <div class="modal__content flex flex-col max-h-full overflow-hidden">
          <div class="max-h-full overflow-hidden flex-1">
            <cropper
              class="cropper flex-1"
              :canvas="{
                maxArea: 4096 * 4096,
              }"
              :src="props.image"
              :stencil-props="{
                aspectRatio: 1.09844559585,
                previewClass: 'preview__dashed-border',
              }"
              @change="change" />
          </div>
          <button v-show="false" class="btn btn-black mt-4">
            {{ $t('UPLOAD_OTHER_IMAGE') }}
          </button>
          <button class="btn btn-primary mt-4 flex-0" @click="save">
            {{ $t('COMMON.SAVE') }}
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup lang="ts">
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

import Modal from '~/components/Modal.vue'
import { useUserStore } from '~/stores/userStore'

const props = defineProps({
  image: {
    type: String,
    default: '',
  },
  onSave: {
    type: Function,
    default: null,
  },
  endpoint: {
    type: String,
    default: null
  }
})

const file = ref(null)

const emit = defineEmits<{
  (e: 'update:model-value', modelValue: string): void
  (e: 'updateImage', modelValue: string): void
  (e: 'closed'): void
}>()

const save = () => {
  if (props.onSave) {
    props.onSave(file.value)
    emit('closed')
  } else {
    setProfilePhoto(file.value, props.endpoint)
    emit('closed')
  }
}

const { setProfilePhoto } = useUserStore()

function change({ coordinates, canvas }) {
  canvas.toBlob(blob => {
    file.value = new File([blob], 'fileName.jpg', { type: 'image/jpeg' })
  }, 'image/jpeg')
}
</script>
<style lang="scss" scoped>
.modal {
  grid-template-areas: 'header . actions' 'content content content';
  grid-template-rows: auto 1fr;
}
</style>
